export enum SWMessageType {
  ENABLE_PRECACHE_TRACER = 'ENABLE_PRECACHE_TRACER',
  PRECACHE_TRACER_METRICS = 'PRECACHE_TRACER_METRICS',
}

export interface EnablePrecacheTracerMessage {
  type: SWMessageType.ENABLE_PRECACHE_TRACER;
}

export interface PrecacheTracerMetricsMessage {
  current: number;
  name: string;
  total: number;
  type: SWMessageType.PRECACHE_TRACER_METRICS;
}

export type SWMessage =
  | EnablePrecacheTracerMessage
  | PrecacheTracerMetricsMessage;
